module.exports = __webpack_public_path__ + "assets/asian_disabled-e35c87.svg";